import { Col, Form, Input, Select, Avatar } from "antd";
import { React } from "react";
import "./SellerAccounts.css";
const SellerUserAdd = (prop) => {
  // eslint-disable-next-line 
  const { Userform, handleUserCreate, selectedRow, isEditModalOpen,RolesData } = prop;
  
  // eslint-disable-next-line

    return (
    <>
      {!isEditModalOpen ? (
        <>
          <Col className="password-change-container">
            <Form
              form={Userform}
              name="Userform"
              autoComplete="off"
              style={
                {
                  // maxWidth: 500,
                }
              }
              layout="vertical"
              onFinish={handleUserCreate}
            >
              <Form.Item
                label={
                  <Col>
                    Person Full name
                    {/* <span className="text-danger"> *</span> */}
                  </Col>
                }
                className=""
                name="person_full_name"
                rules={[
                  {
                    required: true,
                    message: "Please enter full name",
                  },
                ]}
              >
                <Input
                  type="text"
                  defaultValue={selectedRow?.name}
                  className="change-password-input"
                />
              </Form.Item>
              <Form.Item
                label={
                  <span>
                   Phone number{" "}
                    {/* <span className="text-danger"> *</span> */}
                  </span>
                }
                name="phone_number"
                rules={[
                  {
                    required: true,
                    message: "Please enter phone number",
                  },
                  {
                    pattern: /^[0-9]{10}$/,
                    message: "Please enter a valid 10-digit phone number",
                  },
                ]}
              >
                <Input
                  type="text"
                  maxLength={10}
                  inputMode="numeric"
                  onKeyPress={(e) => {
                    if (!/[0-9]/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  className="change-password-input"
                />
              </Form.Item>

              <Form.Item
                label={
                  <Col>
                    Role 
                    {/* <span className="text-danger"> *</span> */}
                  </Col>
                }
                name="groups"
                rules={[
                  {
                    required: false,
                    message: "Please select role",
                  },
                ]}
              >
                <Select
                  className="change-password-input"
                  // defaultValue={selectedRow?.role}
                  placeholder="Select role"
                >
                 
                      <Select.Option >
                       Subadmin
                      </Select.Option>
                   
                </Select>
              </Form.Item>
            </Form>
          </Col>
        </>
      ) : (
        <Col className="password-change-container">
          <Form
            form={Userform}
            name="Userform"
            autoComplete="off"
            style={
              {
                // maxWidth: 500,
              }
            }
            layout="vertical"
            onFinish={handleUserCreate}
          >
            <div className="d-flex">
              {selectedRow?.avatar ? (
                <Avatar
                  src={
                    selectedRow?.avatar
                      ? selectedRow?.avatar
                      : "/MOBAdmin/Content/images/deleteicon.jpg"
                  }
                  className="avatar-6 img-fluid-6 rounded-circle mr-1"
                />
              ) : (
                <span className="member_img">
                  {selectedRow?.person_full_name?.slice(0, 2).toUpperCase()}
                </span>
              )}
              <p className="mt-2">
                <span className="member-name">{selectedRow?.person_full_name}</span>
                <br />
                <span className="member-email">{selectedRow?.email}</span>
              </p>
            </div>
            <Form.Item
              label={
                <Col>
                  Role 
                  {/* <span className="text-danger"> *</span> */}
                </Col>
              }
              name="groups"
              rules={[
                {
                  required: false,
                  message: "Please select role",
                },
              ]}
            >
              <Select
                className="change-password-input"
                defaultValue={selectedRow?.role}
                placeholder="Select role"
              >
              
                    <Select.Option >
                      Subadmin
                    </Select.Option>
                 
              </Select>
            </Form.Item>
            <Form.Item
              label={
                <span>
                  Email id or phone number{" "}
                  {/* <span className="text-danger"> *</span> */}
                </span>
              }
              name="username"
              rules={[
                {
                  required: true,
                  message: "Please enter email id or phone number",
                },
              ]}
            >
              <Input
                type="text"
                defaultValue={selectedRow?.email}
                disabled="true"
                className="change-password-input"
              />
            </Form.Item>
          </Form>
        </Col>
      )}
    </>
  );
};

export default SellerUserAdd;
